export const openContactSupportForm = (errorId: string): void => {
    window.open("https://help.sundaysky.com/hc/en-us/requests/new", "_blank"); // ToDo: pass errorId
};

export const reloadPage = (): void => {
    window.location.reload();
};
